import { render, staticRenderFns } from "./ProductCountWidget.vue?vue&type=template&id=a7640862"
import script from "./ProductCountWidget.vue?vue&type=script&lang=js"
export * from "./ProductCountWidget.vue?vue&type=script&lang=js"
import style0 from "./ProductCountWidget.vue?vue&type=style&index=0&id=a7640862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports